<template>
  <div>
    <vs-alert v-if="$validator.errors.all().length > 0" color="danger" title="Atenção!!" active="true" class="my-3"
      style="height: auto !important">
      <ul>
        <li class="mb-2" v-for="error in $validator.errors.all()" :key="error.id">
          {{ error }}
        </li>
      </ul>
    </vs-alert>
    <form role="form" @submit.prevent="onSubmit">
      <vs-tabs alignment="fixed">
        <vs-tab label="Dados Gerais">
          <div class="vx-row mt-5 mb-4 mt-3">
            <div class="vx-col sm:w-1/1 w-full mb-3">
              <vs-input size="large" class="w-full" label-placeholder="ID" name="ID" id="ID"
                v-model="formCadastro.idExterno" v-validate="{ required: true, min: 6 }" val-icon-danger="clear"
                danger-text="Preencha este Campo" :readOnly="true" />
            </div>
          </div>
          <div class="vx-row mb-4 mt-3">
            <div class="vx-col sm:w-1/2 w-full mb-3">
              <vs-input size="large" class="w-full" label-placeholder="Razao Social" name="Razao Social"
                id="Razao Social" v-model="formCadastro.razaoSocial" v-validate="{ required: true, min: 6 }"
                :state="validateState('Razao Social')" :danger="validateClass('Razao Social')" val-icon-danger="clear"
                danger-text="Preencha este Campo" />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input size="large" class="w-full" label-placeholder="Nome Fantasia" name="Nome Fantasia"
                id="Nome Fantasia" v-model="formCadastro.nomeEmpresa" v-validate="{ required: true, min: 6 }"
                :state="validateState('Nome Fantasia')" :danger="validateClass('Nome Fantasia')" val-icon-danger="clear"
                danger-text="Preencha este Campo" />
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input size="large" class="w-full" :label-placeholder="placeHolderCpf" name="CNPJ" id=""
                v-model="formCadastro.cnpj" v-validate="validateCpf" :state="validateState('CNPJ')"
                :danger="validateClass('CNPJ')" val-icon-danger="clear" danger-text="Preencha este Campo"
                v-mask="mascaraCpf" />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input size="large" class="w-full" label-placeholder="Data de Inicio de Operação"
                name="Data de Inicio de Operação" id="Data de Inicio de Operação"
                v-model="formCadastro.dataInicioOperacao" v-validate="{ required: true, date_format: 'dd/MM/yyyy' }"
                :state="validateState('Data de Inicio de Operação')"
                :danger="validateClass('Data de Inicio de Operação')" val-icon-danger="clear" v-mask="'##/##/####'"
                danger-text="Preencha este Campo" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input size="large" class="w-full" label-placeholder="Email" name="Email" id="Email"
                v-model="formCadastro.email" v-validate="{ required: true, email: true }"
                :state="validateState('Email')" :danger="validateClass('Email')" val-icon-danger="clear"
                danger-text="Preencha este Campo" />
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input size="large" class="w-full" label-placeholder="Central de Atendimento" name="Telefone"
                id="Telefone" v-model="formCadastro.telefone" :state="validateState('Telefone')"
                :danger="validateClass('Telefone')" val-icon-danger="clear" danger-text="Preencha este Campo" />
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Endereço">
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>CEP</span>
              <vs-input size="large" class="w-full" name="Cep" id="Cep" @keyup.native="keymonitor"
                v-model="formCadastro.cep" v-validate="{ required: true, min: 10 }" :state="validateState('Cep')"
                :danger="validateClass('Cep')" val-icon-danger="clear" danger-text="Preencha este Campo"
                v-mask="'##.###-###'" icon-pack="feather" icon="icon-home" icon-no-border />
            </div>
          </div>

          <!-----============================ OBS: API CORREIOS  ==================------->
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Endereço</span>
              <vs-input size="large" class="w-full" name="Endereço" id="Endereço" v-model="formCadastro.endereco"
                v-validate="{ required: true, min: 6 }" :state="validateState('Endereço')"
                :danger="validateClass('Endereço')" val-icon-danger="clear" danger-text="Preencha este Campo"
                icon-pack="feather" icon icon-no-border />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Número</span>
              <vs-input size="large" class="w-full" name="Numero" id="Numero" v-model="formCadastro.numero"
                v-validate="{ required: true }" :state="validateState('Numero')" :danger="validateClass('Numero')"
                val-icon-danger="clear" danger-text="Preencha este Campo" icon-pack="feather" icon="icon-check-circle"
                icon-no-border />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Complemento</span>
              <vs-input size="large" class="w-full" name="Complemento" id="Complemento"
                v-model="formCadastro.complemento" :state="validateState('Complemento')"
                :danger="validateClass('Complemento')" val-icon-danger="clear" danger-text="Preencha este Campo"
                icon-pack="feather" icon="icon-check-circle" icon-no-border />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Bairro</span>
              <vs-input size="large" class="w-full" name="Bairro" id="Bairro" v-model="formCadastro.bairro"
                v-validate="{ required: true }" :state="validateState('Bairro')" :danger="validateClass('Bairro')"
                val-icon-danger="clear" danger-text="Preencha este Campo" icon-pack="feather" icon icon-no-border />
            </div>
          </div>

          <!-----============================ OBS: API CORREIOS  ==================------->
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Cidade</span>
              <vs-input size="large" class="w-full" name="Cidade" id="Cidade" v-model="formCadastro.cidade"
                v-validate="{ required: true }" :state="validateState('Cidade')" :danger="validateClass('Cidade')"
                val-icon-danger="clear" danger-text="Preencha este Campo" icon-pack="feather" icon icon-no-border />
            </div>
          </div>

          <!-----============================ OBS: API CORREIOS  ==================------->
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Estado</span>
              <vs-input size="large" class="w-full" name="Estado" id="Estado" v-model="formCadastro.estado"
                v-validate="{ required: true, min: 2, max: 2 }" :state="validateState('Estado')"
                :danger="validateClass('Estado')" val-icon-danger="clear" danger-text="Preencha este Campo"
                icon-pack="feather" icon icon-no-border />
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Configurações">
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Site</span>
              <vs-input size="large" class="w-full" name="Site" id="Site" v-model="formCadastro.jsonConfiguracoes.site"
                v-validate="{ required: true }" :state="validateState('Site')" :danger="validateClass('Site')"
                val-icon-danger="clear" danger-text="Preencha este Campo" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Email Sender</span>
              <vs-input size="large" class="w-full" name="Email Sender" id="Email Sender"
                v-model="formCadastro.jsonConfiguracoes.emailSender" v-validate="{ required: true, email: true }"
                :state="validateState('Email Sender')" :danger="validateClass('Email Sender')" val-icon-danger="clear"
                danger-text="Preencha este Campo" />
            </div>
          </div>

          <!-----============================ OBS: API CORREIOS  ==================------->
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Servidor SMTP</span>
              <vs-input size="large" class="w-full" name="Servidor SMTP" id="Servidor SMTP"
                v-model="formCadastro.jsonConfiguracoes.servidorSMTP" v-validate="{ required: true }"
                :state="validateState('Servidor SMTP')" :danger="validateClass('Servidor SMTP')" val-icon-danger="clear"
                danger-text="Preencha este Campo" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Porta SMTP</span>
              <vs-input size="large" class="w-full" name="Porta SMTP" id="Porta SMTP"
                v-model="formCadastro.jsonConfiguracoes.portaSMTP" v-validate="{ required: true }"
                :state="validateState('Porta SMTP')" :danger="validateClass('Porta SMTP')" val-icon-danger="clear"
                danger-text="Preencha este Campo" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Senha</span>
              <vs-input size="large" class="w-full" name="Senha" id="Senha"
                v-model="formCadastro.jsonConfiguracoes.senha" :state="validateState('Senha')"
                :danger="validateClass('Senha')" val-icon-danger="clear" danger-text="Preencha este Campo"
                type="password" />
            </div>
          </div>
        </vs-tab>

        <vs-tab label="Logo">
          <div class="vx-row img">
            <div class="vx-col containerimg sm:w-1/2 w-full mb-2 text-center mt-4">
              <h4 class="mb-3">Logo</h4>
              <center>
                <img :src="formCadastro.logo" width="100%" style="max-width: 250px" />
              </center>
              <input id="fileUpload" type="file" hidden v-on:change="selecionaLogo" />
              <vs-button color="warning" type="border" class="mr-3 mt-2 text-center" @click="chooseFiles()">
                Escolher uma Imagem
                <feather-icon icon="UploadIcon" class="ml-2" />
                <Br />
                <vs-chip v-if="nomeLogo" class="mt-3">
                  <vs-avatar icon-pack="feather" icon="icon-file" />
                  <span>{{ nomeLogo }}</span>
                </vs-chip>
              </vs-button>
            </div>

            <div class="vx-col containerimg sm:w-1/2 w-full mb-2 text-center mt-4">
              <h4 class="mb-3">Capa Email</h4>
              <center>
                <img :src="formCadastro.capaEmail" width="100%" style="max-width: 250px" />
              </center>
              <input id="fileUpload3" type="file" hidden v-on:change="selecionaCapaEmail" />
              <vs-button color="warning" type="border" class="mr-3 mt-2 text-center" @click.stop="chooseFiles3()">
                Escolher uma Imagem
                <feather-icon icon="UploadIcon" class="ml-2" />
                <Br />
                <vs-chip v-if="nomeLogo" class="mt-3">
                  <vs-avatar icon-pack="feather" icon="icon-file" />
                  <span>{{ nomeLogo }}</span>
                </vs-chip>
              </vs-button>
            </div>
          </div>
        </vs-tab>

        <vs-tab label="Tema">
          <vs-col vs-justify="center" vs-align="center" vs-w="12">
            <h4 class="mb-4">Geral</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoLogin">Cor de Fundo Site</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundo" id="corDeFundo"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundo" v-validate="{ required: false }"
                    :state="validateState('corDeFundo')" :danger="validateClass('corDeFundo')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundo" id="corDeFundo" :change="changeThemeColor"
                    v-model="temaCor.corDeFundo" v-validate="{ required: false }" :state="validateState('corDeFundo')"
                    :danger="validateClass('corDeFundo')" val-icon-danger="clear" danger-text="Preencha este Campo"
                    icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor do Fundo Topo</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDoBackGroundTopo"
                    id="corDoBackGroundTopo" v-on:change="changeThemeColor" v-model="temaCor.corDoBackGroundTopo"
                    v-validate="{ required: false }" :state="validateState('corDoBackGroundTopo')"
                    :danger="validateClass('corDoBackGroundTopo')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDoBackGroundTopo" id="corDoBackGroundTopo"
                    v-on:change="changeThemeColor" v-model="temaCor.corDoBackGroundTopo"
                    v-validate="{ required: false }" :state="validateState('corDoBackGroundTopo')"
                    :danger="validateClass('corDoBackGroundTopo')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoLogin">Cor de Texto Padrão</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corTextoPadrao" id="corTextoPadrao"
                    v-on:change="changeThemeColor" v-model="temaCor.corTextoPadrao" v-validate="{ required: false }"
                    :state="validateState('corTextoPadrao')" :danger="validateClass('corTextoPadrao')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corTextoPadrao" id="corTextoPadrao" :change="changeThemeColor"
                    v-model="temaCor.corTextoPadrao" v-validate="{ required: false }"
                    :state="validateState('corTextoPadrao')" :danger="validateClass('corTextoPadrao')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor Texto Título das Páginas</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corTextoTituloPaginas"
                    id="corTextoTituloPaginas" v-on:change="changeThemeColor" v-model="temaCor.corTextoTituloPaginas"
                    v-validate="{ required: false }" :state="validateState('corTextoTituloPaginas')"
                    :danger="validateClass('corTextoTituloPaginas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corTextoTituloPaginas" id="corTextoTituloPaginas"
                    v-on:change="changeThemeColor" v-model="temaCor.corTextoTituloPaginas"
                    v-validate="{ required: false }" :state="validateState('corTextoTituloPaginas')"
                    :danger="validateClass('corTextoTituloPaginas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Destaque</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoDestaque"
                    id="corDeTextoDestaque" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoDestaque"
                    v-validate="{ required: false }" :state="validateState('corDeTextoDestaque')"
                    :danger="validateClass('corDeTextoDestaque')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoDestaque" id="corDeTextoDestaque"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoDestaque" v-validate="{ required: false }"
                    :state="validateState('corDeTextoDestaque')" :danger="validateClass('corDeTextoDestaque')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoFormularios">Cor do Fundo botões Selects DropDown</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corFundoBotaoFormularios"
                    id="corFundoBotaoFormularios" v-on:change="changeThemeColor"
                    v-model="temaCor.corFundoBotaoFormularios" v-validate="{ required: false }"
                    :state="validateState('corFundoBotaoFormularios')"
                    :danger="validateClass('corFundoBotaoFormularios')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corFundoBotaoFormularios" id="corFundoBotaoFormularios"
                    v-on:change="changeThemeColor" v-model="temaCor.corFundoBotaoFormularios"
                    v-validate="{ required: false }" :state="validateState('corFundoBotaoFormularios')"
                    :danger="validateClass('corFundoBotaoFormularios')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoFormularios">Cor do Texto dos Selects DropDown</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corTextoBotaoFormularios"
                    id="corTextoBotaoFormularios" v-on:change="changeThemeColor"
                    v-model="temaCor.corTextoBotaoFormularios" v-validate="{ required: false }"
                    :state="validateState('corTextoBotaoFormularios')"
                    :danger="validateClass('corTextoBotaoFormularios')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corTextoBotaoFormularios" id="corTextoBotaoFormularios"
                    v-on:change="changeThemeColor" v-model="temaCor.corTextoBotaoFormularios"
                    v-validate="{ required: false }" :state="validateState('corTextoBotaoFormularios')"
                    :danger="validateClass('corTextoBotaoFormularios')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>
            <hr class="mb-6" />
            <h4 class="mb-4">Botão Destaque</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoLogin">Botão Degradê Cor 1</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="degradeCor1" id="degradeCor1"
                    v-on:change="changeThemeColor" v-model="temaCor.degradeCor1" v-validate="{ required: false }"
                    :state="validateState('degradeCor1')" :danger="validateClass('degradeCor1')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="degradeCor1" id="degradeCor1" :change="changeThemeColor"
                    v-model="temaCor.degradeCor1" v-validate="{ required: false }" :state="validateState('degradeCor1')"
                    :danger="validateClass('degradeCor1')" val-icon-danger="clear" danger-text="Preencha este Campo"
                    icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoLogin">Botão Degradê Cor 2</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="degradeCor2" id="degradeCor2"
                    v-on:change="changeThemeColor" v-model="temaCor.degradeCor2" v-validate="{ required: false }"
                    :state="validateState('degradeCor2')" :danger="validateClass('degradeCor2')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="degradeCor2" id="degradeCor2" :change="changeThemeColor"
                    v-model="temaCor.degradeCor2" v-validate="{ required: false }" :state="validateState('degradeCor2')"
                    :danger="validateClass('degradeCor2')" val-icon-danger="clear" danger-text="Preencha este Campo"
                    icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoLogin">Botão Degradê Cor 1 Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="degradeCor1Hover"
                    id="degradeCor1Hover" v-on:change="changeThemeColor" v-model="temaCor.degradeCor1Hover"
                    v-validate="{ required: false }" :state="validateState('degradeCor1Hover')"
                    :danger="validateClass('degradeCor1Hover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="degradeCor1Hover" id="degradeCor1Hover" :change="changeThemeColor"
                    v-model="temaCor.degradeCor1Hover" v-validate="{ required: false }"
                    :state="validateState('degradeCor1Hover')" :danger="validateClass('degradeCor1Hover')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoLogin">Botão Degradê Cor 2 Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="degradeCor2Hover"
                    id="degradeCor2Hover" v-on:change="changeThemeColor" v-model="temaCor.degradeCor2Hover"
                    v-validate="{ required: false }" :state="validateState('degradeCor2Hover')"
                    :danger="validateClass('degradeCor2Hover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="degradeCor2Hover" id="degradeCor2Hover" :change="changeThemeColor"
                    v-model="temaCor.degradeCor2Hover" v-validate="{ required: false }"
                    :state="validateState('degradeCor2Hover')" :danger="validateClass('degradeCor2Hover')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor Texto Botão Degradê</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corTextoBotao" id="corTextoBotao"
                    v-on:change="changeThemeColor" v-model="temaCor.corTextoBotao" v-validate="{ required: false }"
                    :state="validateState('corTextoBotao')" :danger="validateClass('corTextoBotao')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corTextoBotao" id="corTextoBotao" v-on:change="changeThemeColor"
                    v-model="temaCor.corTextoBotao" v-validate="{ required: false }"
                    :state="validateState('corTextoBotao')" :danger="validateClass('corTextoBotao')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor Texto Botão Degradê Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corTextoBotaoHover"
                    id="corTextoBotaoHover" v-on:change="changeThemeColor" v-model="temaCor.corTextoBotaoHover"
                    v-validate="{ required: false }" :state="validateState('corTextoBotaoHover')"
                    :danger="validateClass('corTextoBotaoHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corTextoBotaoHover" id="corTextoBotaoHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corTextoBotaoHover" v-validate="{ required: false }"
                    :state="validateState('corTextoBotaoHover')" :danger="validateClass('corTextoBotaoHover')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>
            <hr class="mb-6" />
            <h4 class="mb-4">Botão Outline</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoLogin">Cor Borda </label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corBordaBotaoOutline"
                    id="corBordaBotaoOutline" v-on:change="changeThemeColor" v-model="temaCor.corBordaBotaoOutline"
                    v-validate="{ required: false }" :state="validateState('corBordaBotaoOutline')"
                    :danger="validateClass('corBordaBotaoOutline')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corBordaBotaoOutline" id="corBordaBotaoOutline"
                    :change="changeThemeColor" v-model="temaCor.corBordaBotaoOutline" v-validate="{ required: false }"
                    :state="validateState('corBordaBotaoOutline')" :danger="validateClass('corBordaBotaoOutline')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoLogin">Cor Texto</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corTextoBotaoOutline"
                    id="corTextoBotaoOutline" v-on:change="changeThemeColor" v-model="temaCor.corTextoBotaoOutline"
                    v-validate="{ required: false }" :state="validateState('corTextoBotaoOutline')"
                    :danger="validateClass('corTextoBotaoOutline')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corTextoBotaoOutline" id="corTextoBotaoOutline"
                    :change="changeThemeColor" v-model="temaCor.corTextoBotaoOutline" v-validate="{ required: false }"
                    :state="validateState('corTextoBotaoOutline')" :danger="validateClass('corTextoBotaoOutline')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoLogin">Cor Borda Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corBordaBotaoOutlineHover"
                    id="corBordaBotaoOutlineHover" v-on:change="changeThemeColor"
                    v-model="temaCor.corBordaBotaoOutlineHover" v-validate="{ required: false }"
                    :state="validateState('corBordaBotaoOutlineHover')"
                    :danger="validateClass('corBordaBotaoOutlineHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corBordaBotaoOutlineHover" id="corBordaBotaoOutlineHover"
                    :change="changeThemeColor" v-model="temaCor.corBordaBotaoOutlineHover"
                    v-validate="{ required: false }" :state="validateState('corBordaBotaoOutlineHover')"
                    :danger="validateClass('corBordaBotaoOutlineHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoLogin">Cor Texto Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corTextoBotaoOutlineHover"
                    id="corTextoBotaoOutlineHover" v-on:change="changeThemeColor"
                    v-model="temaCor.corTextoBotaoOutlineHover" v-validate="{ required: false }"
                    :state="validateState('corTextoBotaoOutlineHover')"
                    :danger="validateClass('corTextoBotaoOutlineHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corTextoBotaoOutlineHover" id="corTextoBotaoOutlineHover"
                    :change="changeThemeColor" v-model="temaCor.corTextoBotaoOutlineHover"
                    v-validate="{ required: false }" :state="validateState('corTextoBotaoOutlineHover')"
                    :danger="validateClass('corTextoBotaoOutlineHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>
            <hr class="mb-6" />
            <h4 class="mb-4">Menu Mobile</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor de Fundo do Menu Mobile 1 </label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDoBackGroundMenuMobile"
                    id="corDoBackGroundMenuMobile" v-on:change="changeThemeColor"
                    v-model="temaCor.corDoBackGroundMenuMobile" v-validate="{ required: false }"
                    :state="validateState('corDoBackGroundMenuMobile')"
                    :danger="validateClass('corDoBackGroundMenuMobile')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDoBackGroundMenuMobile" id="corDoBackGroundMenuMobile"
                    v-on:change="changeThemeColor" v-model="temaCor.corDoBackGroundMenuMobile"
                    v-validate="{ required: false }" :state="validateState('corDoBackGroundMenuMobile')"
                    :danger="validateClass('corDoBackGroundMenuMobile')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor de Fundo do Menu Mobile 2 </label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDoBackGroundMenuMobile2"
                    id="corDoBackGroundMenuMobile2" v-on:change="changeThemeColor"
                    v-model="temaCor.corDoBackGroundMenuMobile2" v-validate="{ required: false }"
                    :state="validateState('corDoBackGroundMenuMobile2')"
                    :danger="validateClass('corDoBackGroundMenuMobile2')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDoBackGroundMenuMobile" id="corDoBackGroundMenuMobile"
                    v-on:change="changeThemeColor" v-model="temaCor.corDoBackGroundMenuMobile2"
                    v-validate="{ required: false }" :state="validateState('corDoBackGroundMenuMobile2')"
                    :danger="validateClass('corDoBackGroundMenuMobile2')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor dos Links Menu</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDosLinksMenu"
                    id="corDosLinksMenu" v-on:change="changeThemeColor" v-model="temaCor.corDosLinksMenu"
                    v-validate="{ required: false }" :state="validateState('corDosLinksMenu')"
                    :danger="validateClass('corDosLinksMenu')" val-icon-danger="clear" danger-text="Preencha este Campo"
                    icon-no-border />
                  <vs-input class="w-full" name="corDosLinksMenu" id="corDosLinksMenu" v-on:change="changeThemeColor"
                    v-model="temaCor.corDosLinksMenu" v-validate="{ required: false }"
                    :state="validateState('corDosLinksMenu')" :danger="validateClass('corDosLinksMenu')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor dos Links Menu Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDosLinksMenuOver"
                    id="corDosLinksMenuOver" v-on:change="changeThemeColor" v-model="temaCor.corDosLinksMenuOver"
                    v-validate="{ required: false }" :state="validateState('corDosLinksMenuOver')"
                    :danger="validateClass('corDosLinksMenuOver')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDosLinksMenuOver" id="corDosLinksMenuOver"
                    v-on:change="changeThemeColor" v-model="temaCor.corDosLinksMenuOver"
                    v-validate="{ required: false }" :state="validateState('corDosLinksMenuOver')"
                    :danger="validateClass('corDosLinksMenuOver')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor de Fundo do Menu Dropdown </label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoMenuDropDown"
                    id="corDeFundoMenuDropDown" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoMenuDropDown"
                    v-validate="{ required: false }" :state="validateState('corDeFundoMenuDropDown')"
                    :danger="validateClass('corDeFundoMenuDropDown')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoMenuDropDown" id="corDeFundoMenuDropDown"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoMenuDropDown"
                    v-validate="{ required: false }" :state="validateState('corDeFundoMenuDropDown')"
                    :danger="validateClass('corDeFundoMenuDropDown')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor de Texto do Menu Dropdown </label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoMenuDropDown"
                    id="corDeTextoMenuDropDown" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoMenuDropDown"
                    v-validate="{ required: false }" :state="validateState('corDeTextoMenuDropDown')"
                    :danger="validateClass('corDeTextoMenuDropDown')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoMenuDropDown" id="corDeTextoMenuDropDown"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoMenuDropDown"
                    v-validate="{ required: false }" :state="validateState('corDeTextoMenuDropDown')"
                    :danger="validateClass('corDeTextoMenuDropDown')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor de Texto do Menu Dropdown Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoMenuDropDownHover"
                    id="corDeTextoMenuDropDownHover" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoMenuDropDownHover" v-validate="{ required: false }"
                    :state="validateState('corDeTextoMenuDropDownHover')"
                    :danger="validateClass('corDeTextoMenuDropDownHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoMenuDropDownHover" id="corDeTextoMenuDropDownHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoMenuDropDownHover"
                    v-validate="{ required: false }" :state="validateState('corDeTextoMenuDropDownHover')"
                    :danger="validateClass('corDeTextoMenuDropDownHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor do Fundo Saldo</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoSaldo"
                    id="corDeFundoSaldo" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoSaldo"
                    v-validate="{ required: false }" :state="validateState('corDeFundoSaldo')"
                    :danger="validateClass('corDeFundoSaldo')" val-icon-danger="clear" danger-text="Preencha este Campo"
                    icon-no-border />
                  <vs-input class="w-full" name="corDeFundoSaldo" id="corDeFundoSaldo" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoSaldo" v-validate="{ required: false }"
                    :state="validateState('corDeFundoSaldo')" :danger="validateClass('corDeFundoSaldo')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor do Fundo Saldo Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoSaldoHover"
                    id="corDeFundoSaldoHover" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoSaldoHover"
                    v-validate="{ required: false }" :state="validateState('corDeFundoSaldoHover')"
                    :danger="validateClass('corDeFundoSaldoHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoSaldoHover" id="corDeFundoSaldoHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoSaldoHover"
                    v-validate="{ required: false }" :state="validateState('corDeFundoSaldoHover')"
                    :danger="validateClass('corDeFundoSaldoHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor da Borda Saldo</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDaBordaSaldo"
                    id="corDaBordaSaldo" v-on:change="changeThemeColor" v-model="temaCor.corDaBordaSaldo"
                    v-validate="{ required: false }" :state="validateState('corDaBordaSaldo')"
                    :danger="validateClass('corDaBordaSaldo')" val-icon-danger="clear" danger-text="Preencha este Campo"
                    icon-no-border />
                  <vs-input class="w-full" name="corDaBordaSaldo" id="corDaBordaSaldo" v-on:change="changeThemeColor"
                    v-model="temaCor.corDaBordaSaldo" v-validate="{ required: false }"
                    :state="validateState('corDaBordaSaldo')" :danger="validateClass('corDaBordaSaldo')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor da Borda Saldo Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDaBordaSaldoHover"
                    id="corDaBordaSaldoHover" v-on:change="changeThemeColor" v-model="temaCor.corDaBordaSaldoHover"
                    v-validate="{ required: false }" :state="validateState('corDaBordaSaldoHover')"
                    :danger="validateClass('corDaBordaSaldoHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDaBordaSaldoHover" id="corDaBordaSaldoHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDaBordaSaldoHover"
                    v-validate="{ required: false }" :state="validateState('corDaBordaSaldoHover')"
                    :danger="validateClass('corDaBordaSaldoHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor do Texto Saldo</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDoTextoSaldo"
                    id="corDoTextoSaldo" v-on:change="changeThemeColor" v-model="temaCor.corDoTextoSaldo"
                    v-validate="{ required: false }" :state="validateState('corDoTextoSaldo')"
                    :danger="validateClass('corDoTextoSaldo')" val-icon-danger="clear" danger-text="Preencha este Campo"
                    icon-no-border />
                  <vs-input class="w-full" name="corDoTextoSaldo" id="corDoTextoSaldo" v-on:change="changeThemeColor"
                    v-model="temaCor.corDoTextoSaldo" v-validate="{ required: false }"
                    :state="validateState('corDoTextoSaldo')" :danger="validateClass('corDoTextoSaldo')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor do Texto Saldo Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDoTextoSaldoHover"
                    id="corDoTextoSaldoHover" v-on:change="changeThemeColor" v-model="temaCor.corDoTextoSaldoHover"
                    v-validate="{ required: false }" :state="validateState('corDoTextoSaldoHover')"
                    :danger="validateClass('corDoTextoSaldoHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDoTextoSaldoHover" id="corDoTextoSaldoHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDoTextoSaldoHover"
                    v-validate="{ required: false }" :state="validateState('corDoTextoSaldoHover')"
                    :danger="validateClass('corDoTextoSaldoHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor do Icone Saldo</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDoIconeSaldo"
                    id="corDoIconeSaldo" v-on:change="changeThemeColor" v-model="temaCor.corDoIconeSaldo"
                    v-validate="{ required: false }" :state="validateState('corDoIconeSaldo')"
                    :danger="validateClass('corDoIconeSaldo')" val-icon-danger="clear" danger-text="Preencha este Campo"
                    icon-no-border />
                  <vs-input class="w-full" name="corDoIconeSaldo" id="corDoIconeSaldo" v-on:change="changeThemeColor"
                    v-model="temaCor.corDoIconeSaldo" v-validate="{ required: false }"
                    :state="validateState('corDoIconeSaldo')" :danger="validateClass('corDoIconeSaldo')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="alphaLogin">Cor do Icone Saldo Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDoIconeSaldoHover"
                    id="corDoIconeSaldoHover" v-on:change="changeThemeColor" v-model="temaCor.corDoIconeSaldoHover"
                    v-validate="{ required: false }" :state="validateState('corDoIconeSaldoHover')"
                    :danger="validateClass('corDoIconeSaldoHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDoIconeSaldoHover" id="corDoIconeSaldoHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDoIconeSaldoHover"
                    v-validate="{ required: false }" :state="validateState('corDoIconeSaldoHover')"
                    :danger="validateClass('corDoIconeSaldoHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>
            <hr class="mb-6" />
            <h4 class="mb-4">Rodapé</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="topoApp">Cor de Fundo do Rodapé</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoDoRodape"
                    id="corDeFundoDoRodape" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoDoRodape"
                    v-validate="{ required: false }" :state="validateState('corDeFundoDoRodape')"
                    :danger="validateClass('corDeFundoDoRodape')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoDoRodape" id="corDeFundoDoRodape"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoDoRodape" v-validate="{ required: false }"
                    :state="validateState('corDeFundoDoRodape')" :danger="validateClass('corDeFundoDoRodape')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="topoApp">Cor de Texto do Rodapé</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoDoRodape"
                    id="corDeTextoDoRodape" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoDoRodape"
                    v-validate="{ required: false }" :state="validateState('corDeTextoDoRodape')"
                    :danger="validateClass('corDeTextoDoRodape')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoDoRodape" id="corDeTextoDoRodape"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoDoRodape" v-validate="{ required: false }"
                    :state="validateState('corDeTextoDoRodape')" :danger="validateClass('corDeTextoDoRodape')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="topoApp">Cor dos Links do Rodapé</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDosLinksDoRodape"
                    id="corDosLinksDoRodape" v-on:change="changeThemeColor" v-model="temaCor.corDosLinksDoRodape"
                    v-validate="{ required: false }" :state="validateState('corDosLinksDoRodape')"
                    :danger="validateClass('corDosLinksDoRodape')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDosLinksDoRodape" id="corDosLinksDoRodape"
                    v-on:change="changeThemeColor" v-model="temaCor.corDosLinksDoRodape"
                    v-validate="{ required: false }" :state="validateState('corDosLinksDoRodape')"
                    :danger="validateClass('corDosLinksDoRodape')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="topoApp">Cor dos Links do Rodapé Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDosLinksDoRodapeHover"
                    id="corDosLinksDoRodapeHover" v-on:change="changeThemeColor"
                    v-model="temaCor.corDosLinksDoRodapeHover" v-validate="{ required: false }"
                    :state="validateState('corDosLinksDoRodapeHover')"
                    :danger="validateClass('corDosLinksDoRodapeHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDosLinksDoRodapeHover" id="corDosLinksDoRodapeHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDosLinksDoRodapeHover"
                    v-validate="{ required: false }" :state="validateState('corDosLinksDoRodapeHover')"
                    :danger="validateClass('corDosLinksDoRodapeHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>
            <hr class="mb-6" />
            <h4 class="mb-4">Últimas Aberturas</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="bottomBar">Cor de Fundo Box</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoUltimasAberturas"
                    id="corDeFundoUltimasAberturas" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoUltimasAberturas" v-validate="{ required: false }"
                    :state="validateState('corDeFundoUltimasAberturas')"
                    :danger="validateClass('corDeFundoUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoUltimasAberturas" id="corDeFundoUltimasAberturas"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoUltimasAberturas"
                    v-validate="{ required: false }" :state="validateState('corDeFundoUltimasAberturas')"
                    :danger="validateClass('corDeFundoUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="bottomBar">Cor de Fundo Título </label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoTituloUltimasAberturas"
                    id="corDeFundoTituloUltimasAberturas" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoTituloUltimasAberturas" v-validate="{ required: false }"
                    :state="validateState('corDeFundoTituloUltimasAberturas')"
                    :danger="validateClass('corDeFundoTituloUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoTituloUltimasAberturas" id="corDeFundoTituloUltimasAberturas"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoTituloUltimasAberturas"
                    v-validate="{ required: false }" :state="validateState('corDeFundoTituloUltimasAberturas')"
                    :danger="validateClass('corDeFundoTituloUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="bottomBar">Cor de Texto Título </label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoTituloUltimasAberturas"
                    id="corDeTextoTituloUltimasAberturas" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoTituloUltimasAberturas" v-validate="{ required: false }"
                    :state="validateState('corDeTextoTituloUltimasAberturas')"
                    :danger="validateClass('corDeTextoTituloUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoTituloUltimasAberturas" id="corDeTextoTituloUltimasAberturas"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoTituloUltimasAberturas"
                    v-validate="{ required: false }" :state="validateState('corDeTextoTituloUltimasAberturas')"
                    :danger="validateClass('corDeTextoTituloUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="bottomBar">Cor de Borda Título </label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeBordaTituloUltimasAberturas"
                    id="corDeBordaTituloUltimasAberturas" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeBordaTituloUltimasAberturas" v-validate="{ required: false }"
                    :state="validateState('corDeBordaTituloUltimasAberturas')"
                    :danger="validateClass('corDeBordaTituloUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeBordaTituloUltimasAberturas" id="corDeBordaTituloUltimasAberturas"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeBordaTituloUltimasAberturas"
                    v-validate="{ required: false }" :state="validateState('corDeBordaTituloUltimasAberturas')"
                    :danger="validateClass('corDeBordaTituloUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="bottomBar">Cor de Rec Título </label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeRecTituloUltimasAberturas"
                    id="corDeRecTituloUltimasAberturas" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeRecTituloUltimasAberturas" v-validate="{ required: false }"
                    :state="validateState('corDeRecTituloUltimasAberturas')"
                    :danger="validateClass('corDeRecTituloUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeRecTituloUltimasAberturas" id="corDeRecTituloUltimasAberturas"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeRecTituloUltimasAberturas"
                    v-validate="{ required: false }" :state="validateState('corDeRecTituloUltimasAberturas')"
                    :danger="validateClass('corDeRecTituloUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="bottomBar">Cor de Fundo Item</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoItemUltimasAberturas"
                    id="corDeFundoItemUltimasAberturas" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoItemUltimasAberturas" v-validate="{ required: false }"
                    :state="validateState('corDeFundoItemUltimasAberturas')"
                    :danger="validateClass('corDeFundoItemUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoItemUltimasAberturas" id="corDeFundoItemUltimasAberturas"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoItemUltimasAberturas"
                    v-validate="{ required: false }" :state="validateState('corDeFundoItemUltimasAberturas')"
                    :danger="validateClass('corDeFundoItemUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="bottomBar">Cor de Fundo Abreviação</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoAbreviacao"
                    id="corDeFundoAbreviacao" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoAbreviacao"
                    v-validate="{ required: false }" :state="validateState('corDeFundoAbreviacao')"
                    :danger="validateClass('corDeFundoAbreviacao')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoAbreviacao" id="corDeFundoAbreviacao"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoAbreviacao"
                    v-validate="{ required: false }" :state="validateState('corDeFundoAbreviacao')"
                    :danger="validateClass('corDeFundoAbreviacao')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoBottomBar">Cor de Texto Abreviação</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoAbreviacao"
                    id="corDeTextoAbreviacao" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoAbreviacao"
                    v-validate="{ required: false }" :state="validateState('corDeTextoAbreviacao')"
                    :danger="validateClass('corDeTextoAbreviacao')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoAbreviacao" id="corDeTextoAbreviacao"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoAbreviacao"
                    v-validate="{ required: false }" :state="validateState('corDeTextoAbreviacao')"
                    :danger="validateClass('corDeTextoAbreviacao')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoBottomBar">Cor de Fundo Valor</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoValorUltimasAberturas"
                    id="corDeFundoValorUltimasAberturas" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoValorUltimasAberturas" v-validate="{ required: false }"
                    :state="validateState('corDeFundoValorUltimasAberturas')"
                    :danger="validateClass('corDeFundoValorUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoValorUltimasAberturas" id="corDeFundoValorUltimasAberturas"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoValorUltimasAberturas"
                    v-validate="{ required: false }" :state="validateState('corDeFundoValorUltimasAberturas')"
                    :danger="validateClass('corDeFundoValorUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoBottomBar">Cor de Texto Valor</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoValorUltimasAberturas"
                    id="corDeTextoValorUltimasAberturas" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoValorUltimasAberturas" v-validate="{ required: false }"
                    :state="validateState('corDeTextoValorUltimasAberturas')"
                    :danger="validateClass('corDeTextoValorUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoValorUltimasAberturas" id="corDeTextoValorUltimasAberturas"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoValorUltimasAberturas"
                    v-validate="{ required: false }" :state="validateState('corDeTextoValorUltimasAberturas')"
                    :danger="validateClass('corDeTextoValorUltimasAberturas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>
            <hr class="mb-6" />
            <h4 class="mb-4">Banners</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de fundo do Box de Banner</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoDoBoxBanner"
                    id="corDeFundoDoBoxBanner" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoDoBoxBanner"
                    v-validate="{ required: false }" :state="validateState('corDeFundoDoBoxBanner')"
                    :danger="validateClass('corDeFundoDoBoxBanner')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoDoBoxBanner" id="corDeFundoDoBoxBanner"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoDoBoxBanner"
                    v-validate="{ required: false }" :state="validateState('corDeFundoDoBoxBanner')"
                    :danger="validateClass('corDeFundoDoBoxBanner')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>
            <hr class="mb-6" />
            <h4 class="mb-4">Filtros</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de fundo Box Filtro</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoFiltro"
                    id="corDeFundoFiltro" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoFiltro"
                    v-validate="{ required: false }" :state="validateState('corDeFundoFiltro')"
                    :danger="validateClass('corDeFundoFiltro')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoFiltro" id="corDeFundoFiltro" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoFiltro" v-validate="{ required: false }"
                    :state="validateState('corDeFundoFiltro')" :danger="validateClass('corDeFundoFiltro')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de Link Reset</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeLinkResetFiltros"
                    id="corDeLinkResetFiltros" v-on:change="changeThemeColor" v-model="temaCor.corDeLinkResetFiltros"
                    v-validate="{ required: false }" :state="validateState('corDeLinkResetFiltros')"
                    :danger="validateClass('corDeLinkResetFiltros')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeLinkResetFiltros" id="corDeLinkResetFiltros"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeLinkResetFiltros"
                    v-validate="{ required: false }" :state="validateState('corDeLinkResetFiltros')"
                    :danger="validateClass('corDeLinkResetFiltros')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de fundo Itens Filtro</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoItensFiltro"
                    id="corDeFundoItensFiltro" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoItensFiltro"
                    v-validate="{ required: false }" :state="validateState('corDeFundoItensFiltro')"
                    :danger="validateClass('corDeFundoItensFiltro')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoItensFiltro" id="corDeFundoItensFiltro"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoItensFiltro"
                    v-validate="{ required: false }" :state="validateState('corDeFundoItensFiltro')"
                    :danger="validateClass('corDeFundoItensFiltro')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de Texto Itens Filtro</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoItensFiltro"
                    id="corDeTextoItensFiltro" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoItensFiltro"
                    v-validate="{ required: false }" :state="validateState('corDeTextoItensFiltro')"
                    :danger="validateClass('corDeTextoItensFiltro')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoItensFiltro" id="corDeTextoItensFiltro"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoItensFiltro"
                    v-validate="{ required: false }" :state="validateState('corDeTextoItensFiltro')"
                    :danger="validateClass('corDeTextoItensFiltro')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de Borda Itens Filtro</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeBordaItensFiltro"
                    id="corDeBordaItensFiltro" v-on:change="changeThemeColor" v-model="temaCor.corDeBordaItensFiltro"
                    v-validate="{ required: false }" :state="validateState('corDeBordaItensFiltro')"
                    :danger="validateClass('corDeBordaItensFiltro')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeBordaItensFiltro" id="corDeBordaItensFiltro"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeBordaItensFiltro"
                    v-validate="{ required: false }" :state="validateState('corDeBordaItensFiltro')"
                    :danger="validateClass('corDeBordaItensFiltro')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de Texto Itens Filtro Selecionado</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoItensFiltroSelecionado"
                    id="corDeTextoItensFiltroSelecionado" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoItensFiltroSelecionado" v-validate="{ required: false }"
                    :state="validateState('corDeTextoItensFiltroSelecionado')"
                    :danger="validateClass('corDeTextoItensFiltroSelecionado')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoItensFiltroSelecionado" id="corDeTextoItensFiltroSelecionado"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoItensFiltroSelecionado"
                    v-validate="{ required: false }" :state="validateState('corDeTextoItensFiltroSelecionado')"
                    :danger="validateClass('corDeTextoItensFiltroSelecionado')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>
            <hr class="mb-6" />
            <h4 class="mb-4">Caixas</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de fundo dos Boxes</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoDosBoxes"
                    id="corDeFundoDosBoxes" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoDosBoxes"
                    v-validate="{ required: false }" :state="validateState('corDeFundoDosBoxes')"
                    :danger="validateClass('corDeFundoDosBoxes')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoDosBoxes" id="corDeFundoDosBoxes"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoDosBoxes" v-validate="{ required: false }"
                    :state="validateState('corDeFundoDosBoxes')" :danger="validateClass('corDeFundoDosBoxes')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de fundo Boxes Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoBoxesHover"
                    id="corDeFundoBoxesHover" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoBoxesHover"
                    v-validate="{ required: false }" :state="validateState('corDeFundoBoxesHover')"
                    :danger="validateClass('corDeFundoBoxesHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoBoxesHover" id="corDeFundoBoxesHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoBoxesHover"
                    v-validate="{ required: false }" :state="validateState('corDeFundoBoxesHover')"
                    :danger="validateClass('corDeFundoBoxesHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto do Título Boxes</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoTituloBoxes"
                    id="corDeTextoTituloBoxes" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoTituloBoxes"
                    v-validate="{ required: false }" :state="validateState('corDeTextoTituloBoxes')"
                    :danger="validateClass('corDeTextoTituloBoxes')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoTituloBoxes" id="corDeTextoTituloBoxes"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoTituloBoxes"
                    v-validate="{ required: false }" :state="validateState('corDeTextoTituloBoxes')"
                    :danger="validateClass('corDeTextoTituloBoxes')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de fundo do Valor</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoDoValor"
                    id="corDeFundoDoValor" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoDoValor"
                    v-validate="{ required: false }" :state="validateState('corDeFundoDoValor')"
                    :danger="validateClass('corDeFundoDoValor')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoDoValor" id="corDeFundoDoValor"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoDoValor" v-validate="{ required: false }"
                    :state="validateState('corDeFundoDoValor')" :danger="validateClass('corDeFundoDoValor')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto do Valor</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoDoValor"
                    id="corDeTextoDoValor" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoDoValor"
                    v-validate="{ required: false }" :state="validateState('corDeTextoDoValor')"
                    :danger="validateClass('corDeTextoDoValor')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoDoValor" id="corDeTextoDoValor"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoDoValor" v-validate="{ required: false }"
                    :state="validateState('corDeTextoDoValor')" :danger="validateClass('corDeTextoDoValor')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Fundo do Valor Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoDoValorHover"
                    id="corDeFundoDoValorHover" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoDoValorHover"
                    v-validate="{ required: false }" :state="validateState('corDeFundoDoValorHover')"
                    :danger="validateClass('corDeFundoDoValorHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoDoValorHover" id="corDeFundoDoValorHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoDoValorHover"
                    v-validate="{ required: false }" :state="validateState('corDeFundoDoValorHover')"
                    :danger="validateClass('corDeFundoDoValorHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto do Valor Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoDoValorHover"
                    id="corDeTextoDoValorHover" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoDoValorHover"
                    v-validate="{ required: false }" :state="validateState('corDeTextoDoValorHover')"
                    :danger="validateClass('corDeTextoDoValorHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoDoValorHover" id="corDeTextoDoValorHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoDoValorHover"
                    v-validate="{ required: false }" :state="validateState('corDeTextoDoValorHover')"
                    :danger="validateClass('corDeTextoDoValorHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor Borda Botão Desabilitado</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corBordaBotaoDesabilitado"
                    id="corBordaBotaoDesabilitado" v-on:change="changeThemeColor"
                    v-model="temaCor.corBordaBotaoDesabilitado" v-validate="{ required: false }"
                    :state="validateState('corBordaBotaoDesabilitado')"
                    :danger="validateClass('corBordaBotaoDesabilitado')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corBordaBotaoDesabilitado" id="corBordaBotaoDesabilitado"
                    v-on:change="changeThemeColor" v-model="temaCor.corBordaBotaoDesabilitado"
                    v-validate="{ required: false }" :state="validateState('corBordaBotaoDesabilitado')"
                    :danger="validateClass('corBordaBotaoDesabilitado')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor Texto Botão Desabilitado</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corTextoBotaoDesabilitado"
                    id="corTextoBotaoDesabilitado" v-on:change="changeThemeColor"
                    v-model="temaCor.corTextoBotaoDesabilitado" v-validate="{ required: false }"
                    :state="validateState('corTextoBotaoDesabilitado')"
                    :danger="validateClass('corTextoBotaoDesabilitado')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corTextoBotaoDesabilitado" id="corTextoBotaoDesabilitado"
                    v-on:change="changeThemeColor" v-model="temaCor.corTextoBotaoDesabilitado"
                    v-validate="{ required: false }" :state="validateState('corTextoBotaoDesabilitado')"
                    :danger="validateClass('corTextoBotaoDesabilitado')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>
            <hr class="mb-6" />
            <h4 class="mb-4">Como Funciona Home</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de fundo Paginação</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corFundoPaginacao"
                    id="corFundoPaginacao" v-on:change="changeThemeColor" v-model="temaCor.corFundoPaginacao"
                    v-validate="{ required: false }" :state="validateState('corFundoPaginacao')"
                    :danger="validateClass('corFundoPaginacao')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corFundoPaginacao" id="corFundoPaginacao"
                    v-on:change="changeThemeColor" v-model="temaCor.corFundoPaginacao" v-validate="{ required: false }"
                    :state="validateState('corFundoPaginacao')" :danger="validateClass('corFundoPaginacao')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de Fundo Paginação Selecionada</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corFundoPaginacaoSelecionada"
                    id="corFundoPaginacaoSelecionada" v-on:change="changeThemeColor"
                    v-model="temaCor.corFundoPaginacaoSelecionada" v-validate="{ required: false }"
                    :state="validateState('corFundoPaginacaoSelecionada')"
                    :danger="validateClass('corFundoPaginacaoSelecionada')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corFundoPaginacaoSelecionada" id="corFundoPaginacaoSelecionada"
                    v-on:change="changeThemeColor" v-model="temaCor.corFundoPaginacaoSelecionada"
                    v-validate="{ required: false }" :state="validateState('corFundoPaginacaoSelecionada')"
                    :danger="validateClass('corFundoPaginacaoSelecionada')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de fundo Box Como Funciona</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoBoxComoFunciona"
                    id="corDeFundoBoxComoFunciona" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoBoxComoFunciona" v-validate="{ required: false }"
                    :state="validateState('corDeFundoBoxComoFunciona')"
                    :danger="validateClass('corDeFundoBoxComoFunciona')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoBoxComoFunciona" id="corDeFundoBoxComoFunciona"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoBoxComoFunciona"
                    v-validate="{ required: false }" :state="validateState('corDeFundoBoxComoFunciona')"
                    :danger="validateClass('corDeFundoBoxComoFunciona')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de Texto Setas</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoSetas"
                    id="corDeTextoSetas" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoSetas"
                    v-validate="{ required: false }" :state="validateState('corDeTextoSetas')"
                    :danger="validateClass('corDeTextoSetas')" val-icon-danger="clear" danger-text="Preencha este Campo"
                    icon-no-border />
                  <vs-input class="w-full" name="corDeTextoSetas" id="corDeTextoSetas" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoSetas" v-validate="{ required: false }"
                    :state="validateState('corDeTextoSetas')" :danger="validateClass('corDeTextoSetas')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>
            <hr class="mb-6" />
            <h4 class="mb-4">Páginas Internas - Área Logada</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Fundo Menu Interno</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoMenuInterno"
                    id="corDeFundoMenuInterno" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoMenuInterno"
                    v-validate="{ required: false }" :state="validateState('corDeFundoMenuInterno')"
                    :danger="validateClass('corDeFundoMenuInterno')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoMenuInterno" id="corDeFundoMenuInterno"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoMenuInterno"
                    v-validate="{ required: false }" :state="validateState('corDeFundoMenuInterno')"
                    :danger="validateClass('corDeFundoMenuInterno')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Menu Interno</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoMenuInterno"
                    id="corDeTextoMenuInterno" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoMenuInterno"
                    v-validate="{ required: false }" :state="validateState('corDeTextoMenuInterno')"
                    :danger="validateClass('corDeTextoMenuInterno')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoMenuInterno" id="corDeTextoMenuInterno"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoMenuInterno"
                    v-validate="{ required: false }" :state="validateState('corDeTextoMenuInterno')"
                    :danger="validateClass('corDeTextoMenuInterno')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Fundo Páginas Internas</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corFundoPaginasInternas"
                    id="corFundoPaginasInternas" v-on:change="changeThemeColor"
                    v-model="temaCor.corFundoPaginasInternas" v-validate="{ required: false }"
                    :state="validateState('corFundoPaginasInternas')" :danger="validateClass('corFundoPaginasInternas')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corFundoPaginasInternas" id="corFundoPaginasInternas"
                    v-on:change="changeThemeColor" v-model="temaCor.corFundoPaginasInternas"
                    v-validate="{ required: false }" :state="validateState('corFundoPaginasInternas')"
                    :danger="validateClass('corFundoPaginasInternas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Páginas Internas</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoPaginasInternas"
                    id="corDeTextoPaginasInternas" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoPaginasInternas" v-validate="{ required: false }"
                    :state="validateState('corDeTextoPaginasInternas')"
                    :danger="validateClass('corDeTextoPaginasInternas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoPaginasInternas" id="corDeTextoPaginasInternas"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoPaginasInternas"
                    v-validate="{ required: false }" :state="validateState('corDeTextoPaginasInternas')"
                    :danger="validateClass('corDeTextoPaginasInternas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>
            <hr class="mb-6" />
            <h4 class="mb-4">Páginas Detalhe da Caixa</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de fundo da Roleta</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoDaRoleta"
                    id="corDeFundoDaRoleta" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoDaRoleta"
                    v-validate="{ required: false }" :state="validateState('corDeFundoDaRoleta')"
                    :danger="validateClass('corDeFundoDaRoleta')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoDaRoleta" id="corDeFundoDaRoleta"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoDaRoleta" v-validate="{ required: false }"
                    :state="validateState('corDeFundoDaRoleta')" :danger="validateClass('corDeFundoDaRoleta')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor Texto Titulo Item Roleta</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corTextoTituloItemRoleta"
                    id="corTextoTituloItemRoleta" v-on:change="changeThemeColor"
                    v-model="temaCor.corTextoTituloItemRoleta" v-validate="{ required: false }"
                    :state="validateState('corTextoTituloItemRoleta')"
                    :danger="validateClass('corTextoTituloItemRoleta')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corTextoTituloItemRoleta" id="corTextoTituloItemRoleta"
                    v-on:change="changeThemeColor" v-model="temaCor.corTextoTituloItemRoleta"
                    v-validate="{ required: false }" :state="validateState('corTextoTituloItemRoleta')"
                    :danger="validateClass('corTextoTituloItemRoleta')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor Texto Valor Item Roleta</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corTextoValorItemRoleta"
                    id="corTextoValorItemRoleta" v-on:change="changeThemeColor"
                    v-model="temaCor.corTextoValorItemRoleta" v-validate="{ required: false }"
                    :state="validateState('corTextoValorItemRoleta')" :danger="validateClass('corTextoValorItemRoleta')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corTextoValorItemRoleta" id="corTextoValorItemRoleta"
                    v-on:change="changeThemeColor" v-model="temaCor.corTextoValorItemRoleta"
                    v-validate="{ required: false }" :state="validateState('corTextoValorItemRoleta')"
                    :danger="validateClass('corTextoValorItemRoleta')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor Borda de Box de Botões (mobile)</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeBordaDeDetalheDaCaixa"
                    id="corDeBordaDeDetalheDaCaixa" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeBordaDeDetalheDaCaixa" v-validate="{ required: false }"
                    :state="validateState('corDeBordaDeDetalheDaCaixa')"
                    :danger="validateClass('corDeBordaDeDetalheDaCaixa')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeBordaDeDetalheDaCaixa" id="corDeBordaDeDetalheDaCaixa"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeBordaDeDetalheDaCaixa"
                    v-validate="{ required: false }" :state="validateState('corDeBordaDeDetalheDaCaixa')"
                    :danger="validateClass('corDeBordaDeDetalheDaCaixa')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Fundo de Box de Botões (mobile)
                </label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoBox" id="corDeFundoBox"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoBox" v-validate="{ required: false }"
                    :state="validateState('corDeFundoBox')" :danger="validateClass('corDeFundoBox')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoBox" id="corDeFundoBox" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoBox" v-validate="{ required: false }"
                    :state="validateState('corDeFundoBox')" :danger="validateClass('corDeFundoBox')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Fundo da Listagem de Itens</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoDaListagemDeItens"
                    id="corDeFundoDaListagemDeItens" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoDaListagemDeItens" v-validate="{ required: false }"
                    :state="validateState('corDeFundoDaListagemDeItens')"
                    :danger="validateClass('corDeFundoDaListagemDeItens')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoDaListagemDeItens" id="corDeFundoDaListagemDeItens"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoDaListagemDeItens"
                    v-validate="{ required: false }" :state="validateState('corDeFundoDaListagemDeItens')"
                    :danger="validateClass('corDeFundoDaListagemDeItens')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto do Título da Listagem de Itens</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corTextoTituloListagemItens"
                    id="corTextoTituloListagemItens" v-on:change="changeThemeColor"
                    v-model="temaCor.corTextoTituloListagemItens" v-validate="{ required: false }"
                    :state="validateState('corTextoTituloListagemItens')"
                    :danger="validateClass('corTextoTituloListagemItens')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corTextoTituloListagemItens" id="corTextoTituloListagemItens"
                    v-on:change="changeThemeColor" v-model="temaCor.corTextoTituloListagemItens"
                    v-validate="{ required: false }" :state="validateState('corTextoTituloListagemItens')"
                    :danger="validateClass('corTextoTituloListagemItens')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Fundo do Item </label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoItem" id="corDeFundoItem"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoItem" v-validate="{ required: false }"
                    :state="validateState('corDeFundoItem')" :danger="validateClass('corDeFundoItem')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoItem" id="corDeFundoItem" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoItem" v-validate="{ required: false }"
                    :state="validateState('corDeFundoItem')" :danger="validateClass('corDeFundoItem')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Fundo do Item Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoItemHover"
                    id="corDeFundoItemHover" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoItemHover"
                    v-validate="{ required: false }" :state="validateState('corDeFundoItemHover')"
                    :danger="validateClass('corDeFundoItemHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoItemHover" id="corDeFundoItemHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoItemHover"
                    v-validate="{ required: false }" :state="validateState('corDeFundoItemHover')"
                    :danger="validateClass('corDeFundoItemHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto da odd do Item </label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoOddItem"
                    id="corDeTextoOddItem" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoOddItem"
                    v-validate="{ required: false }" :state="validateState('corDeTextoOddItem')"
                    :danger="validateClass('corDeTextoOddItem')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoOddItem" id="corDeTextoOddItem"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoOddItem" v-validate="{ required: false }"
                    :state="validateState('corDeTextoOddItem')" :danger="validateClass('corDeTextoOddItem')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Titulo do Item </label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoTituloItem"
                    id="corDeTextoTituloItem" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoTituloItem"
                    v-validate="{ required: false }" :state="validateState('corDeTextoTituloItem')"
                    :danger="validateClass('corDeTextoTituloItem')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoTituloItem" id="corDeTextoTituloItem"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoTituloItem"
                    v-validate="{ required: false }" :state="validateState('corDeTextoTituloItem')"
                    :danger="validateClass('corDeTextoTituloItem')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Titulo do Item Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoTituloItemHover"
                    id="corDeTextoTituloItemHover" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoTituloItemHover" v-validate="{ required: false }"
                    :state="validateState('corDeTextoTituloItemHover')"
                    :danger="validateClass('corDeTextoTituloItemHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoTituloItemHover" id="corDeTextoTituloItemHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoTituloItemHover"
                    v-validate="{ required: false }" :state="validateState('corDeTextoTituloItemHover')"
                    :danger="validateClass('corDeTextoTituloItemHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Fundo Valor</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="CorDeFundoValorItem"
                    id="CorDeFundoValorItem" v-on:change="changeThemeColor" v-model="temaCor.CorDeFundoValorItem"
                    v-validate="{ required: false }" :state="validateState('CorDeFundoValorItem')"
                    :danger="validateClass('CorDeFundoValorItem')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="CorDeFundoValorItem" id="CorDeFundoValorItem"
                    v-on:change="changeThemeColor" v-model="temaCor.CorDeFundoValorItem"
                    v-validate="{ required: false }" :state="validateState('CorDeFundoValorItem')"
                    :danger="validateClass('CorDeFundoValorItem')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Fundo Valor Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="CorDeFundoValorItemHover"
                    id="CorDeFundoValorItemHover" v-on:change="changeThemeColor"
                    v-model="temaCor.CorDeFundoValorItemHover" v-validate="{ required: false }"
                    :state="validateState('CorDeFundoValorItemHover')"
                    :danger="validateClass('CorDeFundoValorItemHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="CorDeFundoValorItemHover" id="CorDeFundoValorItemHover"
                    v-on:change="changeThemeColor" v-model="temaCor.CorDeFundoValorItemHover"
                    v-validate="{ required: false }" :state="validateState('CorDeFundoValorItemHover')"
                    :danger="validateClass('CorDeFundoValorItemHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Valor </label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="CorDeTextoValorItem"
                    id="CorDeTextoValorItem" v-on:change="changeThemeColor" v-model="temaCor.CorDeTextoValorItem"
                    v-validate="{ required: false }" :state="validateState('CorDeTextoValorItem')"
                    :danger="validateClass('CorDeTextoValorItem')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="CorDeTextoValorItem" id="CorDeTextoValorItem"
                    v-on:change="changeThemeColor" v-model="temaCor.CorDeTextoValorItem"
                    v-validate="{ required: false }" :state="validateState('CorDeTextoValorItem')"
                    :danger="validateClass('CorDeTextoValorItem')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Valor Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="CorDeTextoValorItemHover"
                    id="CorDeTextoValorItemHover" v-on:change="changeThemeColor"
                    v-model="temaCor.CorDeTextoValorItemHover" v-validate="{ required: false }"
                    :state="validateState('CorDeTextoValorItemHover')"
                    :danger="validateClass('CorDeTextoValorItemHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="CorDeTextoValorItemHover" id="CorDeTextoValorItemHover"
                    v-on:change="changeThemeColor" v-model="temaCor.CorDeTextoValorItemHover"
                    v-validate="{ required: false }" :state="validateState('CorDeTextoValorItemHover')"
                    :danger="validateClass('CorDeTextoValorItemHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>
            <hr class="mb-6" />
            <h4 class="mb-4">Botões</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de fundo Botão Primário Formulários</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoBotaoPrimarioFormularios"
                    id="corDeFundoBotaoPrimarioFormularios" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoBotaoPrimarioFormularios" v-validate="{ required: false }"
                    :state="validateState('corDeFundoBotaoPrimarioFormularios')" :danger="validateClass('corDeFundoBotaoPrimarioFormularios')
                      " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoBotaoPrimarioFormularios"
                    id="corDeFundoBotaoPrimarioFormularios" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoBotaoPrimarioFormularios" v-validate="{ required: false }"
                    :state="validateState('corDeFundoBotaoPrimarioFormularios')" :danger="validateClass('corDeFundoBotaoPrimarioFormularios')
                      " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de fundo Botão Primário Formulários Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker"
                    name="corDeFundoBotaoPrimarioFormulariosHover" id="corDeFundoBotaoPrimarioFormulariosHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoBotaoPrimarioFormulariosHover"
                    v-validate="{ required: false }" :state="validateState('corDeFundoBotaoPrimarioFormulariosHover')
                      " :danger="validateClass('corDeFundoBotaoPrimarioFormulariosHover')
                        " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoBotaoPrimarioFormulariosHover"
                    id="corDeFundoBotaoPrimarioFormulariosHover" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoBotaoPrimarioFormulariosHover" v-validate="{ required: false }" :state="validateState('corDeFundoBotaoPrimarioFormulariosHover')
                      " :danger="validateClass('corDeFundoBotaoPrimarioFormulariosHover')
                        " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Botão Primário Formulários</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoBotaoPrimarioFormularios"
                    id="corDeTextoBotaoPrimarioFormularios" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoBotaoPrimarioFormularios" v-validate="{ required: false }"
                    :state="validateState('corDeTextoBotaoPrimarioFormularios')" :danger="validateClass('corDeTextoBotaoPrimarioFormularios')
                      " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoBotaoPrimarioFormularios"
                    id="corDeTextoBotaoPrimarioFormularios" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoBotaoPrimarioFormularios" v-validate="{ required: false }"
                    :state="validateState('corDeTextoBotaoPrimarioFormularios')" :danger="validateClass('corDeTextoBotaoPrimarioFormularios')
                      " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Botão Primário Formulários Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker"
                    name="corDeTextoBotaoPrimarioFormulariosHover" id="corDeTextoBotaoPrimarioFormulariosHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoBotaoPrimarioFormulariosHover"
                    v-validate="{ required: false }" :state="validateState('corDeTextoBotaoPrimarioFormulariosHover')
                      " :danger="validateClass('corDeTextoBotaoPrimarioFormulariosHover')
                        " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoBotaoPrimarioFormulariosHover"
                    id="corDeTextoBotaoPrimarioFormulariosHover" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoBotaoPrimarioFormulariosHover" v-validate="{ required: false }" :state="validateState('corDeTextoBotaoPrimarioFormulariosHover')
                      " :danger="validateClass('corDeTextoBotaoPrimarioFormulariosHover')
                        " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de fundo Botão Vender Item</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoBotaoVenderItem"
                    id="corDeFundoBotaoVenderItem" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoBotaoVenderItem" v-validate="{ required: false }"
                    :state="validateState('corDeFundoBotaoVenderItem')"
                    :danger="validateClass('corDeFundoBotaoVenderItem')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoBotaoVenderItem" id="corDeFundoBotaoVenderItem"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoBotaoVenderItem"
                    v-validate="{ required: false }" :state="validateState('corDeFundoBotaoVenderItem')"
                    :danger="validateClass('corDeFundoBotaoVenderItem')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de fundo Botão Vender Item Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoBotaoVenderItemHover"
                    id="corDeFundoBotaoVenderItemHover" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoBotaoVenderItemHover" v-validate="{ required: false }"
                    :state="validateState('corDeFundoBotaoVenderItemHover')"
                    :danger="validateClass('corDeFundoBotaoVenderItemHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoBotaoVenderItemHover" id="corDeFundoBotaoVenderItemHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoBotaoVenderItemHover"
                    v-validate="{ required: false }" :state="validateState('corDeFundoBotaoVenderItemHover')"
                    :danger="validateClass('corDeFundoBotaoVenderItemHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Botão Vender Item</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoBotaoVenderItem"
                    id="corDeTextoBotaoVenderItem" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoBotaoVenderItem" v-validate="{ required: false }"
                    :state="validateState('corDeTextoBotaoVenderItem')"
                    :danger="validateClass('corDeTextoBotaoVenderItem')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoBotaoVenderItem" id="corDeTextoBotaoVenderItem"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoBotaoVenderItem"
                    v-validate="{ required: false }" :state="validateState('corDeTextoBotaoVenderItem')"
                    :danger="validateClass('corDeTextoBotaoVenderItem')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Botão Vender Item Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoBotaoVenderItemHover"
                    id="corDeTextoBotaoVenderItemHover" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoBotaoVenderItemHover" v-validate="{ required: false }"
                    :state="validateState('corDeTextoBotaoVenderItemHover')"
                    :danger="validateClass('corDeTextoBotaoVenderItemHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoBotaoVenderItemHover" id="corDeTextoBotaoVenderItemHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoBotaoVenderItemHover"
                    v-validate="{ required: false }" :state="validateState('corDeTextoBotaoVenderItemHover')"
                    :danger="validateClass('corDeTextoBotaoVenderItemHover')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de fundo Botão Solicitar Entrega</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoBotaoSolicitarEntrega"
                    id="corDeFundoBotaoSolicitarEntrega" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoBotaoSolicitarEntrega" v-validate="{ required: false }"
                    :state="validateState('corDeFundoBotaoSolicitarEntrega')"
                    :danger="validateClass('corDeFundoBotaoSolicitarEntrega')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoBotaoSolicitarEntrega" id="corDeFundoBotaoSolicitarEntrega"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoBotaoSolicitarEntrega"
                    v-validate="{ required: false }" :state="validateState('corDeFundoBotaoSolicitarEntrega')"
                    :danger="validateClass('corDeFundoBotaoSolicitarEntrega')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de fundo Botão Solicitar Entrega Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker"
                    name="corDeFundoBotaoSolicitarEntregaHover" id="corDeFundoBotaoSolicitarEntregaHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoBotaoSolicitarEntregaHover"
                    v-validate="{ required: false }" :state="validateState('corDeFundoBotaoSolicitarEntregaHover')
                      " :danger="validateClass('corDeFundoBotaoSolicitarEntregaHover')
                        " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoBotaoSolicitarEntregaHover"
                    id="corDeFundoBotaoSolicitarEntregaHover" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoBotaoSolicitarEntregaHover" v-validate="{ required: false }" :state="validateState('corDeFundoBotaoSolicitarEntregaHover')
                      " :danger="validateClass('corDeFundoBotaoSolicitarEntregaHover')
                        " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Botão Solicitar Entrega</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoBotaoSolicitarEntrega"
                    id="corDeTextoBotaoSolicitarEntrega" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoBotaoSolicitarEntrega" v-validate="{ required: false }"
                    :state="validateState('corDeTextoBotaoSolicitarEntrega')"
                    :danger="validateClass('corDeTextoBotaoSolicitarEntrega')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoBotaoSolicitarEntrega" id="corDeTextoBotaoSolicitarEntrega"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoBotaoSolicitarEntrega"
                    v-validate="{ required: false }" :state="validateState('corDeTextoBotaoSolicitarEntrega')"
                    :danger="validateClass('corDeTextoBotaoSolicitarEntrega')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Botão Solicitar Entrega Hover</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker"
                    name="corDeTextoBotaoSolicitarEntregaHover" id="corDeTextoBotaoSolicitarEntregaHover"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoBotaoSolicitarEntregaHover"
                    v-validate="{ required: false }" :state="validateState('corDeTextoBotaoSolicitarEntregaHover')
                      " :danger="validateClass('corDeTextoBotaoSolicitarEntregaHover')
                        " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoBotaoSolicitarEntregaHover"
                    id="corDeTextoBotaoSolicitarEntregaHover" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoBotaoSolicitarEntregaHover" v-validate="{ required: false }" :state="validateState('corDeTextoBotaoSolicitarEntregaHover')
                      " :danger="validateClass('corDeTextoBotaoSolicitarEntregaHover')
                        " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>
            <hr class="mb-6" />
            <h4 class="mb-4">Página Como Funciona</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de fundo Box</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoBoxesPaginaComoFunciona"
                    id="corDeFundoBoxesPaginaComoFunciona" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoBoxesPaginaComoFunciona" v-validate="{ required: false }"
                    :state="validateState('corDeFundoBoxesPaginaComoFunciona')"
                    :danger="validateClass('corDeFundoBoxesPaginaComoFunciona')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoBoxesPaginaComoFunciona"
                    id="corDeFundoBoxesPaginaComoFunciona" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoBoxesPaginaComoFunciona" v-validate="{ required: false }"
                    :state="validateState('corDeFundoBoxesPaginaComoFunciona')"
                    :danger="validateClass('corDeFundoBoxesPaginaComoFunciona')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de texto Boxes</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoBoxesPaginaComoFunciona"
                    id="corDeTextoBoxesPaginaComoFunciona" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoBoxesPaginaComoFunciona" v-validate="{ required: false }"
                    :state="validateState('corDeTextoBoxesPaginaComoFunciona')"
                    :danger="validateClass('corDeTextoBoxesPaginaComoFunciona')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoBoxesPaginaComoFunciona"
                    id="corDeTextoBoxesPaginaComoFunciona" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoBoxesPaginaComoFunciona" v-validate="{ required: false }"
                    :state="validateState('corDeTextoBoxesPaginaComoFunciona')"
                    :danger="validateClass('corDeTextoBoxesPaginaComoFunciona')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Titulo Boxes</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker"
                    name="corDeTextoTituloBoxesPaginaComoFunciona" id="corDeTextoTituloBoxesPaginaComoFunciona"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoTituloBoxesPaginaComoFunciona"
                    v-validate="{ required: false }" :state="validateState('corDeTextoTituloBoxesPaginaComoFunciona')
                      " :danger="validateClass('corDeTextoTituloBoxesPaginaComoFunciona')
                        " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoTituloBoxesPaginaComoFunciona"
                    id="corDeTextoTituloBoxesPaginaComoFunciona" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoTituloBoxesPaginaComoFunciona" v-validate="{ required: false }" :state="validateState('corDeTextoTituloBoxesPaginaComoFunciona')
                      " :danger="validateClass('corDeTextoTituloBoxesPaginaComoFunciona')
                        " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Título Destaque</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker"
                    name="corDeTextoTituloDestaqueBoxesPaginaComoFunciona"
                    id="corDeTextoTituloDestaqueBoxesPaginaComoFunciona" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoTituloDestaqueBoxesPaginaComoFunciona
                      " v-validate="{ required: false }" :state="validateState(
                        'corDeTextoTituloDestaqueBoxesPaginaComoFunciona'
                      )
                        " :danger="validateClass(
                          'corDeTextoTituloDestaqueBoxesPaginaComoFunciona'
                        )
                          " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoTituloDestaqueBoxesPaginaComoFunciona"
                    id="corDeTextoTituloDestaqueBoxesPaginaComoFunciona" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoTituloDestaqueBoxesPaginaComoFunciona
                      " v-validate="{ required: false }" :state="validateState(
                        'corDeTextoTituloDestaqueBoxesPaginaComoFunciona'
                      )
                        " :danger="validateClass(
                          'corDeTextoTituloDestaqueBoxesPaginaComoFunciona'
                        )
                          " val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>
            <hr class="mb-6" />
            <h4 class="mb-4">Página FAQ</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de Fundo Pergunta</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoPergunta"
                    id="corDeFundoPergunta" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoPergunta"
                    v-validate="{ required: false }" :state="validateState('corDeFundoPergunta')"
                    :danger="validateClass('corDeFundoPergunta')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoPergunta" id="corDeFundoPergunta"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoPergunta" v-validate="{ required: false }"
                    :state="validateState('corDeFundoPergunta')" :danger="validateClass('corDeFundoPergunta')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de texto Pergunta</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoPergunta"
                    id="corDeTextoPergunta" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoPergunta"
                    v-validate="{ required: false }" :state="validateState('corDeTextoPergunta')"
                    :danger="validateClass('corDeTextoPergunta')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoPergunta" id="corDeTextoPergunta"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoPergunta" v-validate="{ required: false }"
                    :state="validateState('corDeTextoPergunta')" :danger="validateClass('corDeTextoPergunta')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de Fundo Número Pergunta</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoNumeroPergunta"
                    id="corDeFundoNumeroPergunta" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoNumeroPergunta" v-validate="{ required: false }"
                    :state="validateState('corDeFundoNumeroPergunta')"
                    :danger="validateClass('corDeFundoNumeroPergunta')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoNumeroPergunta" id="corDeFundoNumeroPergunta"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoNumeroPergunta"
                    v-validate="{ required: false }" :state="validateState('corDeFundoNumeroPergunta')"
                    :danger="validateClass('corDeFundoNumeroPergunta')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de texto Número Pergunta</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoNumeroPergunta"
                    id="corDeTextoNumeroPergunta" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoNumeroPergunta" v-validate="{ required: false }"
                    :state="validateState('corDeTextoNumeroPergunta')"
                    :danger="validateClass('corDeTextoNumeroPergunta')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoNumeroPergunta" id="corDeTextoNumeroPergunta"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoNumeroPergunta"
                    v-validate="{ required: false }" :state="validateState('corDeTextoNumeroPergunta')"
                    :danger="validateClass('corDeTextoNumeroPergunta')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Borda Perguntas</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeBordaPerguntas"
                    id="corDeBordaPerguntas" v-on:change="changeThemeColor" v-model="temaCor.corDeBordaPerguntas"
                    v-validate="{ required: false }" :state="validateState('corDeBordaPerguntas')"
                    :danger="validateClass('corDeBordaPerguntas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeBordaPerguntas" id="corDeBordaPerguntas"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeBordaPerguntas"
                    v-validate="{ required: false }" :state="validateState('corDeBordaPerguntas')"
                    :danger="validateClass('corDeBordaPerguntas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor da Seta</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDaSeta" id="corDaSeta"
                    v-on:change="changeThemeColor" v-model="temaCor.corDaSeta" v-validate="{ required: false }"
                    :state="validateState('corDaSeta')" :danger="validateClass('corDaSeta')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDaSeta" id="corDaSeta" v-on:change="changeThemeColor"
                    v-model="temaCor.corDaSeta" v-validate="{ required: false }" :state="validateState('corDaSeta')"
                    :danger="validateClass('corDaSeta')" val-icon-danger="clear" danger-text="Preencha este Campo"
                    icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="botaoPrimario">Cor de Fundo Resposta</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoResposta"
                    id="corDeFundoResposta" v-on:change="changeThemeColor" v-model="temaCor.corDeFundoResposta"
                    v-validate="{ required: false }" :state="validateState('corDeFundoResposta')"
                    :danger="validateClass('corDeFundoResposta')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoResposta" id="corDeFundoResposta"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoResposta" v-validate="{ required: false }"
                    :state="validateState('corDeFundoResposta')" :danger="validateClass('corDeFundoResposta')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de texto Resposta</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoResposta"
                    id="corDeTextoResposta" v-on:change="changeThemeColor" v-model="temaCor.corDeTextoResposta"
                    v-validate="{ required: false }" :state="validateState('corDeTextoResposta')"
                    :danger="validateClass('corDeTextoResposta')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoResposta" id="corDeTextoResposta"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoResposta" v-validate="{ required: false }"
                    :state="validateState('corDeTextoResposta')" :danger="validateClass('corDeTextoResposta')"
                    val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>
            <hr class="mb-6" />
            <h4 class="mb-4">Páginas Genéricas</h4>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor Fundo Titulo Páginas Genericas</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeFundoTituloPaginasGenericas"
                    id="corDeFundoTituloPaginasGenericas" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeFundoTituloPaginasGenericas" v-validate="{ required: false }"
                    :state="validateState('corDeFundoTituloPaginasGenericas')"
                    :danger="validateClass('corDeFundoTituloPaginasGenericas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeFundoTituloPaginasGenericas" id="corDeFundoTituloPaginasGenericas"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeFundoTituloPaginasGenericas"
                    v-validate="{ required: false }" :state="validateState('corDeFundoTituloPaginasGenericas')"
                    :danger="validateClass('corDeFundoTituloPaginasGenericas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tituloPrimario">Cor de Texto Titulo Páginas Genericas</label>
                <div class="input-group-color">
                  <input type="color" size="large" class="w-full color-picker" name="corDeTextoTituloPaginasGenericas"
                    id="corDeTextoTituloPaginasGenericas" v-on:change="changeThemeColor"
                    v-model="temaCor.corDeTextoTituloPaginasGenericas" v-validate="{ required: false }"
                    :state="validateState('corDeTextoTituloPaginasGenericas')"
                    :danger="validateClass('corDeTextoTituloPaginasGenericas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                  <vs-input class="w-full" name="corDeTextoTituloPaginasGenericas" id="corDeTextoTituloPaginasGenericas"
                    v-on:change="changeThemeColor" v-model="temaCor.corDeTextoTituloPaginasGenericas"
                    v-validate="{ required: false }" :state="validateState('corDeTextoTituloPaginasGenericas')"
                    :danger="validateClass('corDeTextoTituloPaginasGenericas')" val-icon-danger="clear"
                    danger-text="Preencha este Campo" icon-no-border />
                </div>
              </div>
            </div>

            <hr class="mb-6" />
            <h4>Icones Redes Sociais</h4>
            <h6 class="mb-4">Coloque apenas o link.</h6>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 mb-6">
                <label for="instagram">Instagram</label>
                <div class="flex items-center">
                  <i class="ri-instagram-line"></i>
                  <vs-input class="w-full" id="instagram" v-model="formCadastro.socialLinks.instagram.link"
                    v-on:change="changeSocialLink" placeholder="https://instagram.com/suaempresa" />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="tiktok">TikTok</label>
                <div class="flex items-center">
                  <i class="ri-tiktok-line"></i>
                  <vs-input class="w-full" id="tiktok" v-model="formCadastro.socialLinks.tiktok.link"
                    v-on:change="changeSocialLink" placeholder="https://tiktok.com/@suaempresa" />
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-6">
                <label for="facebook">Facebook</label>
                <div class="flex items-center">
                  <i class="ri-facebook-fill"></i>
                  <vs-input class="w-full" id="facebook" v-model="formCadastro.socialLinks.facebook.link"
                    v-on:change="changeSocialLink" placeholder="https://facebook.com/suaempresa" />
                </div>
              </div>
            </div>

          </vs-col>
        </vs-tab>
      </vs-tabs>

      <div class="vx-row">
        <div class="vx-col w-full text-right mt-5">
          <vs-button color="warning" type="border" class="mr-3 mb-2" @click.stop.prevent="onReset">Cancelar</vs-button>

          <BotaoSubmit variant="success" :edit="true" :aguarde="aguardeCadastro" reference="BtnEditar"></BotaoSubmit>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import locale from "../../../../locale";
import * as lang from "vuejs-datepicker/src/locale";
import service from "../../../../services";
import cpfCnpj from "../../../../services/cpfCnpj";
import BotaoSubmit from "./../../../../components/BotaoSubmit";
import jwt from "jsonwebtoken";
import vSelect from "vue-select";
import dataFunctions from "../../../../utils/dateConversion";

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    contadorRender: {
      type: Number,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
    contadorRender() {
      this.preencheForm();
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      pf: false,
      pj: false,
      fotoAtual: 0,
      currentPage: 1,
      pageCount: 0,
      hasImage: false,
      files: new FormData(),
      image: null,
      selectedPessoa: "PJ",
      mascaraCpf: "##.###.###/####-##",
      validateCpf: { required: true, length: 18 },
      placeHolderCpf: "CNPJ",
      placeHolderNome: "Razão Social",
      languages: lang,
      nomeLogo: null,
      capaEmail: null,
      nomeRegulamento: null,
      funcoesValicao: null,
      temaCor: {},
      idExterno: null,
      formCadastro: {
        idEmpresa: null,
        nome: null,
        email: null,
        cnpj: null,
        telefone: null,
        telefoneAssistencia: null,
        logo: null,
        regulamento: null,
        diasVencimento: [],
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        estado: null,
        pais: "Brasil",
        razaoSocial: null,
        capaEmail: null,
        dataInicioOperacao: null,
        temaCor: {},
        jsonConfiguracoes: {},
        socialLinks: {
          instagram: { icon: 'ri-instagram-line', link: '' },
          facebook: { icon: 'ri-facebook-fill', link: '' },
          tiktok: { icon: 'ri-tiktok-line', link: '' }
        }
      },
    };
  },
  methods: {
    preencheForm() {
      if (this.dados.idEmpresa) {
        this.formCadastro.idEmpresa = this.dados.idEmpresa;
        this.formCadastro.idEmpresaAux = this.dados.idEmpresa;
        this.formCadastro.idExterno = this.dados.idExterno;
        this.formCadastro.nomeEmpresa = this.dados.nomeEmpresa;
        this.formCadastro.email = this.dados.email;
        this.formCadastro.cnpj = this.dados.cnpj;
        this.formCadastro.telefone = this.dados.telefone;
        this.formCadastro.logo = this.dados.logo;
        this.formCadastro.cep = this.dados.cep;
        this.formCadastro.endereco = this.dados.endereco;
        this.formCadastro.numero = this.dados.numero;
        this.formCadastro.complemento = this.dados.complemento;
        this.formCadastro.bairro = this.dados.bairro;
        this.formCadastro.cidade = this.dados.cidade;
        this.formCadastro.estado = this.dados.estado;
        this.formCadastro.razaoSocial = this.dados.razaoSocial;
        this.formCadastro.capaEmail = this.dados.capaEmail;
        this.formCadastro.socialLinks = this.dados.socialLinks
          ? JSON.parse(this.dados.socialLinks)
          : {
            instagram: { icon: 'ri-instagram-line', link: '' },
            facebook: { icon: 'ri-facebook-fill', link: '' },
            tiktok: { icon: 'ri-tiktok-line', link: '' }
          };


        this.formCadastro.dataInicioOperacao = this.dados.dataInicioOperacao
          ? dataFunctions.converteISOToDate(this.dados.dataInicioOperacao)
          : null;

        this.formCadastro.temaCor = this.dados.temaCor
          ? JSON.parse(this.dados.temaCor)
          : {};

        this.temaCor = this.formCadastro.temaCor;

        this.formCadastro.jsonConfiguracoes = this.dados.jsonConfiguracoes
          ? JSON.parse(this.dados.jsonConfiguracoes)
          : {};
      } else {
        this.resetForm();
      }
    },
    selecionaLogo(event) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.files.set("file", event.target.files[0], event.target.files[0].name);
      this.nomeLogo = event.target.files[0].name;

      this.$vs.loading();
      service
        .upload("Upload", "logo/" + this.formCadastro.idEmpresa, this.files)
        .then((response) => {
          this.formCadastro.logo = response;
          this.$vs.loading.close();
        })
        .catch(function (e) {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    selecionaCapaEmail(event) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.files.set("file", event.target.files[0], event.target.files[0].name);
      this.capaEmail = event.target.files[0].name;

      this.$vs.loading();
      service
        .upload(
          "Upload",
          "capaEmail/" + this.formCadastro.idEmpresa,
          this.files
        )
        .then((response) => {
          this.formCadastro.capaEmail = response;
          this.$vs.loading.close();
        })
        .catch(function (e) {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Lorem ipsum dolor sit amet, consectetur",
      });
    },
    chooseFiles() {
      document.getElementById("fileUpload").click();
    },
    chooseFiles2() {
      document.getElementById("fileUpload2").click();
    },
    chooseFiles3() {
      document.getElementById("fileUpload3").click();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscaDadosCadastro() {
      if (localStorage.getItem("user-token")) {
        try {
          this.$vs.loading();
          const decoded = jwt.decode(localStorage.getItem("user-token"));
          this.formCadastro.idEmpresa = decoded.id_empresa;

          service
            .getAll(
              "g",
              {},
              "empresas/list/idEmpresa/" + this.formCadastro.idEmpresa
            )
            .then((res) => {
              const [Empresa] = res.data;
              this.temaCor = JSON.parse(Empresa.temaCor);
              this.idExterno = Empresa.idExterno;

              Object.keys(this.formCadastro).forEach((element) => {
                if (element == "diasVencimento") {
                  this.formCadastro.diasVencimento =
                    res.data[0][element].split(",");
                } else this.formCadastro[element] = res.data[0][element];

                if (element == "cnpj" || element == "cpf") {
                  if (res.data[0][element].length > 14) {
                    this.pj = true;
                  } else {
                    this.pf = true;
                  }
                }
              });

              this.$vs.loading.close();
            })
            .catch((e) => {
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: e,
                color: "danger",
              });
              this.$vs.loading.close();
            });
        } catch (error) {
          return error;
        }
      }
    },
    startImageResize() {
      this.carregando = true;
    },
    endImageResize() {
      this.carregando = false;
    },
    keymonitor: function () {
      if (this.formCadastro.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.formCadastro.cep.replace(".", "").replace("-", "");
        service
          .post("g", "BuscaCEP", {
            cep: cepbusca,
          })
          .then((res) => {
            this.formCadastro.endereco = res.data.street;
            this.formCadastro.bairro = res.data.neighborhood;
            this.formCadastro.cidade = res.data.city;
            this.formCadastro.estado = res.data.state;
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Não Foi possível encontrar o cep",
              color: "danger",
            });
          });
      }
    },
    setImage: function (output) {
      this.necessitaUpload = true;
      this.hasImage = true;
      this.image = output;
      this.imgUrl = output.dataUrl;
      this.styleFoto = "display:none";
    },
    onSubmit() {
      if (cpfCnpj.valida_cpf_cnpj(this.formCadastro.cnpj) == false) {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: `Este ${this.placeHolderCpf} não é válido`,
          color: "danger",
        });
        return;
      }

      const dadosEnvio = {
        ...this.formCadastro,
        socialLinks: JSON.stringify(this.formCadastro.socialLinks)
      };


      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .put("Empresas", "Atualizar/" + this.formCadastro.idEmpresa, dadosEnvio)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: "Dados Atualizados com sucesso",
                color: "success",
              });
            })
            .catch(() => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: "Não foi possível atualizar os Dados",
                color: "danger",
              });
            });
        }
      });
    },
    resetForm() {
      this.formCadastro = {
        idEmpresa: null,
        nome: null,
        email: null,
        cnpj: null,
        telefone: null,
        telefoneAssistencia: null,
        logo: null,
        regulamento: null,
        diasVencimento: [],
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        estado: null,
        pais: "Brasil",
        razaoSocial: null,
        capaEmail: null,
        dataInicioOperacao: null,
        jsonConfiguracoes: {},
        temaCor: {},
        socialLinks: {
          instagram: { icon: 'ri-instagram-line', link: '' },
          facebook: { icon: 'ri-facebook-fill', link: '' },
          tiktok: { icon: 'ri-tiktok-line', link: '' }
        }
      };
      this.$nextTick(() => {
        this.show = true;
      });
    },
    changeThemeColor(event) {
      const { value, name } = event.target;
      const objTemaCor = JSON.parse(this.formCadastro.temaCor);

      objTemaCor[name] = value;
      //this.formCadastro.temaCor = JSON.stringify(objTemaCor);
      this.formCadastro.temaCor = objTemaCor;
    },
  },
  created() {
    this.$validator.localize("ptBr", locale);
  },
  mounted() {
    this.preencheForm();
  },
  components: {
    BotaoSubmit,
    vSelect,
  },
};
</script>
<style>
.social-links {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 10px;
}

.social-links li {
  display: flex;
  justify-content: center;
  align-items: center;
}

.social-links li a {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: #19191b;
  font-size: 24px;
  color: #5e5e5e;
  transition: background-color 0.3s;
  text-decoration: none;
}

.social-links li a:hover {
  background-color: #555;
  color: #fff;
}

#fileInput {
  display: none;
}

.img label {
  width: 100%;
  font-weight: normal;
}

.img .containericone {
  text-align: center;
  border-radius: 10px;
  padding: 10px 20px;
  -webkit-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  width: min-content;
  margin-top: 25px;
  margin-left: 43%;
  border: 1px solid #ccc;
}

.img .icone {
  font-size: 50px;
  color: #333;
}

.input-group-color {
  display: flex !important;
  gap: 5px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.color-picker {
  max-width: 2.5rem;
  height: 2.375rem;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
}
</style>
